import Questions from "../components/Quote/Questions";
import CaptureForm from "../components/Quote/CaptureForm";
import Review from "../components/Quote/Review";
import CallUs from "../components/Quote/CallUs";

export const routes = [
    { path: '/build', component: Questions, name: 'Questions' },
    { path: '/get', component: CaptureForm, name: 'CaptureForm' },
    { path: '/review', component: Review, name: 'Review' },
    { path: '/call', component: CallUs, name: 'CallUs' },
];
